<template>
  <svg
    fill="none"
    height="30"
    role="img"
    viewBox="0 0 20 30"
    width="20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Down Arrow</title>
    <path d="M17.7942 7.5L10 21L2.20577 7.5H17.7942Z" stroke="black" />
  </svg>
</template>
